import Error403 from '../../../components/pages/errorPage/Error403'
import Error404 from '../../../components/pages/errorPage/Error404'
import Error500 from '../../../components/pages/errorPage/Error500'
import ErrorUnknown from '../../../components/pages/errorPage/ErrorUnknown'

const error403 = {
  path: 'error/403',
  component: Error403,
  meta: {
    transient: true
  }
}

const error404 = {
  path: 'error/404',
  component: Error404,
  meta: {
    transient: true
  }
}

const error500 = {
  path: 'error/500',
  component: Error500,
  meta: {
    transient: true
  }
}

const errorUnknown = {
  path: 'error/unknown',
  component: ErrorUnknown,
  meta: {
    transient: true
  }
}

const errorPage = [error403, error404, error500, errorUnknown]

export default errorPage
